/** How close (px) to the list end a scroll must reach before the next page is requested. */
export const LOAD_MORE_THRESHOLD_PX = 48;

/**
 * True once the scroll container is within `threshold` of its end — requests
 * the next page slightly early so rows arrive before the user hits bottom.
 */
export const isNearScrollEnd = (
  el: Pick<HTMLElement, "scrollHeight" | "scrollTop" | "clientHeight">,
  threshold: number = LOAD_MORE_THRESHOLD_PX,
): boolean => el.scrollHeight - el.scrollTop - el.clientHeight <= threshold;
